defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/HelpButton',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril',
    'Shared/Framework/Ensighten/Scripts/Ensighten',
    'DanskeSpil/Framework/NumberGames/Scripts/Templates/Overlay',
    'DanskeSpil/Domain/NumberGames/Scripts/Templates/GenericOverlay'
  ],
  function (m, Ensighten, Overlay, GenericOverlay) {
    // Context:
    var HelpButton = function (args) {
      var title = args.title;
      var description = args.description;

      var infoOverlayDictionary = {
        dismiss: args.closeButtonLabel
      };
      if (title) infoOverlayDictionary.header = title;
      if (description) infoOverlayDictionary.body = description;

      var openOverlay = function () {
        Ensighten.pushGaEvent('spil_sammen', 'cta_click', 'åben hjælp');
        return new Overlay(GenericOverlay(infoOverlayDictionary)).show();
      };

      // Return:
      return title || description ? m('.play-together-help-overlay-button', {
        onclick: openOverlay
      }, m('svg', { class: 'icon' }, [
        m('use', { href: '/Components/DanskeSpil/Domain/NumberGames/Graphics/SpriteSheets/MultiClientCommonIcons.svg#question-icon' })
      ])) : null;
    };

    // Public functions:
    return HelpButton;
  });